var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-container flex-valign"},[_c('ioc-tab-group',{attrs:{"option":_vm.calType},on:{"change":_vm.handleChange}}),_c('visitor-area',{ref:"treeConfig",attrs:{"areaType":_vm.areaType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }